/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Measure_Latency_EstimateInputs */

const en_measure_latency_estimate = /** @type {(inputs: Measure_Latency_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Response time estimate`)
};

const zh_hans1_measure_latency_estimate = /** @type {(inputs: Measure_Latency_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`响应时间估算`)
};

const pt_br2_measure_latency_estimate = /** @type {(inputs: Measure_Latency_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimativa do tempo de resposta`)
};

const es_measure_latency_estimate = /** @type {(inputs: Measure_Latency_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimación del tiempo de respuesta`)
};

const fr_measure_latency_estimate = /** @type {(inputs: Measure_Latency_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimation du temps de réponse`)
};

const de_measure_latency_estimate = /** @type {(inputs: Measure_Latency_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschätzte Antwortzeit`)
};

const ru_measure_latency_estimate = /** @type {(inputs: Measure_Latency_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оценка времени ответа`)
};

const it_measure_latency_estimate = /** @type {(inputs: Measure_Latency_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stima del tempo di risposta`)
};

/**
* | output |
* | --- |
* | "Response time estimate" |
*
* @param {Measure_Latency_EstimateInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_latency_estimate = /** @type {((inputs?: Measure_Latency_EstimateInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Latency_EstimateInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_latency_estimate(inputs)
	if (locale === "pt-BR") return pt_br2_measure_latency_estimate(inputs)
	if (locale === "es") return es_measure_latency_estimate(inputs)
	if (locale === "fr") return fr_measure_latency_estimate(inputs)
	if (locale === "de") return de_measure_latency_estimate(inputs)
	if (locale === "ru") return ru_measure_latency_estimate(inputs)
	if (locale === "it") return it_measure_latency_estimate(inputs)
	return en_measure_latency_estimate(inputs)
});